
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import ProjectGeneralSettings from '@/views/Project/Settings/views/General.vue'
import ProjectModulesSettings from '@/views/Project/Settings/views/Modules.vue'
import { getProject, projectSettingsFields } from '@/utils/project'
const ProjectWizzardSettings = Vue.extend({
    mixins: [AppMixin],
    components: { DialogTemplate, ProjectGeneralSettings, ProjectModulesSettings },
    props: {
        props: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            loading: false,
            project: null as null | Record<string, any>,
            step: 0,
            steps: ['general', 'modules'],
            valid: false,
        }
    },

    computed: {
        company() {
            return this.props.company
        },
        projectId() {
            return this.props.projectId
        },
    },

    methods: {
        submit() {
            this.loading = true
        },
        updateProject(data, nextStep = false) {
            this.project = this.lodash.merge(this.project, data)
            if (nextStep) {
                this.step += 1
            }
        },
    },

    async mounted() {
        if (this.projectId) {
            this.loading = true
            const res = await getProject(
                this.projectId,
                'hseBoardDescriptionAttachments,owner,modules.module',
                projectSettingsFields
            )
            if (res && res.id) {
                this.project = res
            }
            this.loading = false
        }
    },
})

export default ProjectWizzardSettings
